import {Component} from 'react';
import "./_App.scss";
import {connect} from "react-redux";
import {Redirect, Route, Switch} from "react-router-dom";
import NotAccess from './components/pages/auth/notAccess';
import routes from "./config/routes";
import DashboardLayout from "./components/atoms/layout";
import Settings from './components/pages/settings';
import CreatorOnBoarding from './components/pages/creator/onBoarding';
import CreatorBuilder from './components/pages/creator/experienceBuilder';

import ParticipantsManager from './components/pages/creator/experienceManager/participantsDashboard';
import ParticipantsInvite from './components/pages/creator/experienceManager/participantsDashboard/participantInviting'
import Overview from './components/pages/creator/experienceManager/overview';
import KnownOverview from './components/pages/creator/experienceManager/overview/known';


import ComparisionManager from './components/pages/creator/experienceManager/compare';
import CreatorDashboard from './components/pages/creator/dashboard';
import AdminRoleList from './components/pages/admin/role';
import AdminUserList from './components/pages/admin/user';
import AdminBilling from './components/pages/admin/user/billing/';
import LiveAnalysis from "./components/pages/creator/experienceManager/analysis";
import ParticipantDashboard from './components/pages/participant/experience';
import PlanningStep1 from './components/pages/participant/planning/step1';
import PlanningStep2 from './components/pages/participant/planning/step2';
import PlanningStep3 from './components/pages/participant/planning/step3';
import PlanningStep4 from './components/pages/participant/planning/step4';
import PlanningStep5 from './components/pages/participant/planning/step5';
import Notification from './components/pages/notification';
import PlanningStep6 from './components/pages/participant/planning/PlanningStep6';
import UtilService from "./helper/service";
import roles from "./helper/roles";
import ParticipantListDetail from "./components/pages/participant/list/detail/IndexPage";
import ParticipantLists from "./components/pages/participant/list/IndexPage";
import HubConnect from "./components/pages/creator/experienceBuilder/liveExperience/hubConnect";
import {FlagsProvider} from 'flagged';

interface IProps {
  loginUser: any,
  userLogout: boolean
}

interface IState {
  loginUserData: any,
  configuredFeatureFlags: string[]
}

class MainContainer extends Component<IProps, IState> {

  goto() {
    let url = `/user/profile`;
    const userData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
    const onboardingFinished = localStorage.getItem('onboardingFinished') ? localStorage.getItem('onboardingFinished') : '';
    const overviewpage = localStorage.getItem("overviewRedirect")
    if (!!userData) {
      if (UtilService.checkTrialAccess(userData, roles['trial']['profile'])) {
        url = `/subscriber/user/profile`
      }
      if(userData && userData.role_access && userData.role_access.length > 0) {
        const creator_dashboard = userData.role_access.filter((val:any)=>val.access_name === "creator_dashboard");
        if(creator_dashboard.length > 0 && creator_dashboard[0].access_value) {
          if(!!overviewpage) {
            url = overviewpage
          } else {
            url = "/creator/dashboard"
          }
        } else if (UtilService.checkTrialAccess(userData, roles['trial']['dashboard'])) {
          if(!!overviewpage) {
            url = overviewpage
          } else {
            url = "/subscriber/creator/dashboard"
          }
        } else {
          const participant_dashboard = userData.role_access.filter((val:any)=>val.access_name === "participant_dashboard")
          if(participant_dashboard.length > 0 && participant_dashboard[0].access_value){
            url = "/participant/dashboard"
          }
        }

        if (!onboardingFinished && userData.hasOwnProperty('creator_on_board') && userData.creator_on_board) {
          const creator_onboarding = userData.role_access.filter((val: any) => val.access_name === "creator_onboarding");
          const trial_onboarding = userData.role_access.filter((val: any) => val.access_name === "trial_onboarding");
          if (creator_onboarding.length > 0 && creator_onboarding[0].access_value) {
            url = "/creator/onboarding"
          } else if (trial_onboarding.length > 0 && trial_onboarding[0].access_value) {
            url = "/subscriber/creator/onboarding";
          }
        }
      }
    }
    return url;
  }

  parseFeatures(roleAccess: any) {
    //const arrFeatures = ['feature_allow_all'];
    const ud = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : [];
    const arrFeatures = !!ud && ud.subscription_entitlements ? ud.subscription_entitlements : [];
    
    //if (arrFeatures.length == 0) {
      for (const item of roleAccess) {
        if (item.access_value === true) {
          arrFeatures.push(item.access_name);
        }
      }
    //  localStorage.setItem("user_features", JSON.stringify(arrFeatures));
    //}
    return arrFeatures;
  }


  render() {
    const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || '{}') : "";
    const configuredFeatureFlags = !!loginUserData && loginUserData.role_access ? this.parseFeatures(loginUserData.role_access) : [];
    const { loginUser, userLogout } = this.props;
    const routesItems = routes;
    const withoutLoginUrl = [
      '/user/login',
      '/user/login/email-password',
      '/user/register',
      '/user/begin',
      '/user/success',
      '/user/failure',
      '/user/confirm-email',
      '/user/create-password',
      '/user/forgot-password',
      '/user/reset-password',
      '/user/account-verification',
      '/deeplink'
    ];

    //check url is available or not in routes
    let notFound = true;
    const findPath = withoutLoginUrl.filter((ele) => window.location.pathname.indexOf(ele) !== -1)
    if (findPath.length > 0) {
      notFound = false
    }

    const checkAuthRoutes = routesItems.filter((ele: any) => ele.access_path.includes(window.location.pathname))
    console.log(checkAuthRoutes);
    if (checkAuthRoutes.length > 0) {
      notFound = false
    }

    const AuthRoute = ({ component: Component, authUser, path, ...rest }: any) => {
      //check user have access of this routes or not
      let is_access = false;
      //get route path from routes file

console.log(path);

      const getRoute = routesItems.find((ele) => ele.access_path.includes(path));
console.log(getRoute);
      let data: any = ""
      if (loginUserData) {
        if (Array.isArray(getRoute?.access_name)) {
          getRoute?.access_name.forEach((name: any) => {
            const tempData = loginUserData.role_access.filter((ele: any) => ele.access_name === name)
            if (tempData.length) {
              data = tempData
            }
          })
        } else {
          data = loginUserData.role_access.filter((ele: any) => ele.access_name === getRoute?.access_name)
        }
      }

      if (getRoute && data.length > 0 && data[0].access_value) {
        is_access = true
      }

      return (
        <Route
          exact
          {...rest}
          render={props => (
            authUser && loginUserData ? (
              <>
              <FlagsProvider features={configuredFeatureFlags}>
                <DashboardLayout>
                  {is_access ? <Component {...props} /> : <NotAccess />}
                </DashboardLayout>
              </FlagsProvider>  
              </>
            ) : (
                <Redirect
                  to={{
                    pathname: '/user/login',
                    state: { from: props.location }
                  }}
                />
              )
          )}
        />
      );
    };

    const rscString = localStorage.getItem("rscString")
    let route = "/user/login"
    if(rscString && rscString !== null && rscString !== ""){
      route = "/user/login?rsc="+rscString
    }

    return (
      <Switch>
        {
          CUSTOMROUTES.map((item, index) =>
            <AuthRoute
              key={index}
              path={item.path}
              authUser={loginUser}
              component={item.component}
            />)
        }

        {!localStorage.getItem("overviewRedirect") && notFound && !userLogout && <Redirect to='/404' />}
        {localStorage.getItem("overviewRedirect") && <Redirect to='/user/login' />}
        {
          loginUser && loginUserData && window.location.pathname !== "/deeplink/" && window.location.pathname !== "/user/account-verification" &&
          <Redirect to={this.goto()} />
        }
        {((notFound && !loginUser) || window.location.pathname === '/') && <Redirect to={route} />}
      </Switch>
    );
  }
}

const mapStateToProps = (state: any) => {
  const { user: loginUser, is_loaded, userLogout } = state.authUser;
  return { loginUser, is_loaded, userLogout };
};

const mapDispatchToProps = () => {
  return {};
};

const Routes = connect(mapStateToProps, mapDispatchToProps)(MainContainer);

export { Routes };

const CUSTOMROUTES = [
  // admin
  { path: '/admin/role', component: AdminRoleList },
  { path: '/admin/user', component: AdminUserList },

  { path: '/admin/billing', component: AdminBilling },
  //admin subscriber
  { path: '/subscriber/admin/user', component: AdminUserList },
  { path: '/subscriber/admin/billing', component: AdminBilling },

  // user
  { path: '/user/profile', component: Settings },

  // creator
  { path: '/creator/experience-manager/overview/:session_code', component: Overview },
  { path: '/creator/experience-manager/participants/:session_code', component: ParticipantsManager },
  { path: '/creator/experience-manager/invite/:session_code', component: ParticipantsInvite},
  { path: '/creator/experience-manager/manage-hubs', component: HubConnect },
  { path: '/creator/experience-manager/compare/:session_code', component: ComparisionManager },
  { path: '/creator/experience-manager/analyze/:session_code', component: LiveAnalysis },
  { path: '/creator/experience-builder', component: CreatorBuilder },

  { path: '/creator/experience-manager/koverview/:session_code', component: KnownOverview },


  { path: '/creator/onboarding', component: CreatorOnBoarding },
  { path: '/creator/dashboard', component: CreatorDashboard },
  
  // participant
  { path: '/participant/dashboard', component: ParticipantDashboard },
  { path: '/participant/planning/1', component: PlanningStep1 },
  { path: '/participant/planning/2', component: PlanningStep2 },
  { path: '/participant/planning/3', component: PlanningStep3 },
  { path: '/participant/planning/4', component: PlanningStep4 },
  { path: '/participant/planning/5', component: PlanningStep5 },
  { path: '/participant/planning/6', component: PlanningStep6 },
  { path: '/participant/lists', component: ParticipantLists },
  { path: '/participant/list/:list_id/detail', component: ParticipantListDetail },

  // trail
  { path: '/subscriber/user/profile', component: Settings },
  { path: '/subscriber/creator/onboarding', component: CreatorOnBoarding },
  { path: '/subscriber/creator/dashboard', component: CreatorDashboard },
  { path: '/subscriber/creator/experience-manager/overview/:session_code', component: Overview },
  { path: '/subscriber/creator/experience-manager/koverview/:session_code', component: KnownOverview },
  { path: '/subscriber/creator/experience-manager/participants/:session_code', component: ParticipantsManager },
  { path: '/subscriber/creator/experience-manager/invite/:session_code', component: ParticipantsInvite},
  { path: '/subscriber/creator/experience-manager/manage-hubs', component: HubConnect},
  { path: '/subscriber/creator/experience-manager/compare/:session_code', component: ComparisionManager },
  { path: '/subscriber/creator/experience-manager/analyze/:session_code', component: LiveAnalysis },
  { path: '/subscriber/creator/experience-builder', component: CreatorBuilder },


  { path: '/user/notification', component: Notification },
]
